export var successCancel = {
    requestId: 'MSWMOCK-a2355033-bc0f-4dc8-a16f-a856f26f9ccd',
    timestamp: '2024-04-25 12:48:59',
    type: 'LOAN',
    data: {
        provider: 'pragma',
        loanId: 123,
        taxId: '1234567890',
        reason: 'some reason',
    },
};
